import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import {
	type ComponentPropsWithoutRef,
	type ElementRef,
	forwardRef,
} from "react";
import { cn } from "../lib/cn";

const Collapsible = forwardRef<
	ElementRef<typeof CollapsiblePrimitive.Root>,
	ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Root>
>(({ className, ...props }, ref) => (
	<CollapsiblePrimitive.Root ref={ref} className={cn(className)} {...props} />
));
Collapsible.displayName = "Collapsible";

const CollapsibleTrigger = forwardRef<
	ElementRef<typeof CollapsiblePrimitive.CollapsibleTrigger>,
	ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleTrigger>
>(({ className, ...props }, ref) => (
	<CollapsiblePrimitive.CollapsibleTrigger
		ref={ref}
		className={cn(className)}
		{...props}
	/>
));
CollapsibleTrigger.displayName = "CollapsibleTrigger";

const CollapsibleContent = forwardRef<
	ElementRef<typeof CollapsiblePrimitive.CollapsibleContent>,
	ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent>
>(({ className, ...props }, ref) => (
	<CollapsiblePrimitive.CollapsibleContent
		ref={ref}
		className={cn(
			"data-[state=open]:animate-collapsible-down data-[state=closed]:animate-collapsible-up overflow-hidden",
			className,
		)}
		{...props}
	/>
));
CollapsibleContent.displayName = "CollapsibleContent";

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
